module.exports = __webpack_public_path__ + "img/Connect Your Account.3217a39b.svg";